import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import InputMask from "react-text-mask";
import moment from "moment";
import { DATA_PATTERN } from "../../utils/patterns";

const FORMATO = "DD/MM/YYYY";

// Campo de data dd/mm/aaaa com máscara e botão de calendário ao lado.
// onChange recebe um evento no formato { target: { name, value } } (igual ao do campo digitado).
const CampoData = ({ id, name, value, onChange, placeholder = "dia/mês/ano", disabled, minimo }) => {
  const seletor = useRef();
  const nomeCampo = name || id;
  const data = moment(value || "", FORMATO, true);
  const valorNativo = data.isValid() ? data.format("YYYY-MM-DD") : "";

  const abrirCalendario = () => {
    const el = seletor.current;
    if (!el || disabled) return;
    if (typeof el.showPicker === "function") {
      try {
        el.showPicker();
        return;
      } catch (e) {
        // segue para o fallback
      }
    }
    el.focus();
    el.click();
  };

  const escolher = e => {
    const escolhida = moment(e.target.value, "YYYY-MM-DD", true);
    onChange({ target: { name: nomeCampo, value: escolhida.isValid() ? escolhida.format(FORMATO) : "" } });
  };

  return (
    <div className="va-campo-data">
      <InputMask
        type="text"
        id={id}
        name={nomeCampo}
        mask={DATA_PATTERN}
        guide={true}
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
      />
      <button type="button" className="va-campo-data-botao" onClick={abrirCalendario} disabled={disabled} aria-label="Escolher a data no calendário" title="Escolher no calendário">
        <Icon name="calendar alternate outline" />
      </button>
      <input
        ref={seletor}
        type="date"
        className="va-campo-data-nativo"
        tabIndex={-1}
        aria-hidden="true"
        value={valorNativo}
        min={minimo}
        onChange={escolher}
      />
    </div>
  );
};

CampoData.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CampoData;
